import React from 'react'
import OAMSider from '../oam-sider'
import ClusterManager from '../components/cluster-manager/ClusterManager'
import {
  Layout,
} from 'antd'

const OAMClusterManager:React.FC =() =>{
  return (
    <Layout style={{ minHeight: '100vh', backgroundColor: '#f5f6f8' }}>
      <OAMSider keys={'cluster_manager'} openKeys={['']}></OAMSider>
      <ClusterManager mode={"oam"} />
    </Layout>
  )
}

export default OAMClusterManager